import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-active-deactive-user-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule, NgMultiSelectDropDownModule],
  templateUrl: './active-deactive-user-dialog.component.html',
  styleUrl: './active-deactive-user-dialog.component.scss'
})
export class ActiveDeactiveUserDialogComponent {

  userData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ActiveDeactiveUserDialogComponent>,
  ) {
    this.userData = JSON.parse(JSON.stringify(data));

  }

  activeInactivateModel() {
    this.userData.active = !this.userData.active;
    this.dialogRef.close(this.userData);
  }

  cancelActiveInactivateModel() {
    this.dialogRef.close();
  }
}
